import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Modal from "../modal";
import Button from "../button";
import IconClose from "../icons/close";
import Gallery from "../gallery";
import IconSpinner from "../icons/spinner";

import { changeFloor } from "../../redux/actions/options";
import { getSpaceDetails } from "../../redux/selectors/space";

class Floor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showLoading: true,
        };

        this._onClose = this._onClose.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.setState({
                showLoading: !this.props.space,
            });
        } else if (!this.props.visible && prevProps.visible) {
            this.setState({
                showLoading: false,
            });
        }
    }

    _onClose() {
        this.props.changeFloor(false);
    }

    render() {
        const { visible, space } = this.props;
        const { showLoading } = this.state;

        let textColor = "text-blue";
        let buttonBackgroundColor = "bg-blue";
        let buttonTextColor = "text-white";
        let borderColor = "border-blue";

        if (!space) {
            if (!showLoading) return <Modal visible={visible} />;

            return (
                <Modal
                    visible={visible}
                    maxWidth={"xl:max-w-2xl"}
                    closeWithOverlay
                    onClose={this._onClose}
                >
                    <div
                        className="flex items-center justify-center bg-orange rounded"
                        style={{ minHeight: "200px" }}
                    >
                        <IconSpinner className="animate-spin w-20 xl:w-32 h-20 xl:h-32 text-blue" />
                    </div>
                </Modal>
            );
        }

        let maxWidth = "xl:max-w-2xl";
        if (space.gallery && space.gallery.length > 0)
            maxWidth = "xl:max-w-5xl";

        return (
            <Modal
                visible={visible}
                maxWidth={maxWidth}
                closeWithOverlay
                onClose={this._onClose}
            >
                <div
                    className="flex flex-col h-max p-32 bg-pink rounded"
                    style={{ minHeight: "200px" }}
                >
                    <div className="flex mb-40">
                        <div className="flex-1">
                            <p className="font-judge font-bold text-30 text-blue">
                                {space.name}
                            </p>
                        </div>
                        <Button
                            icon={
                                <IconClose
                                    className={
                                        "w-20 h-20 md:w-25 md:h-25 z-10 transition hover-hover:group-hover:" +
                                        buttonTextColor +
                                        " " +
                                        textColor
                                    }
                                />
                            }
                            backgroundColorOver={buttonBackgroundColor}
                            borderColor={borderColor}
                            onClick={this._onClose}
                            style="w-50 md:w-70"
                            height="h-32 md:h-46"
                        />
                    </div>
                    <div className="flex">
                        <div className="mr-32">
                            <p className="text-17 whitespace-pre-line">
                                {space.description}
                            </p>
                        </div>
                        {space.gallery && space.gallery.length > 0 && (
                            <Gallery
                                name={space.name}
                                arrowsBottom={true}
                                padding={null}
                                customStyle={{ width: 560 }}
                                data={space.gallery}
                                pagBulletClass={"custom-2-pagination-bullet"}
                                pagBulletActiveClass={
                                    "custom-2-pagination-bullet-active"
                                }
                            />
                        )}
                    </div>
                </div>
            </Modal>
        );
    }
}

Floor.defaultProps = {};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    visible: state.options.isFloorVisible,
    space: getSpaceDetails(state, state.options.floorSlug),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            changeFloor,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Floor);
